module.exports = __webpack_public_path__ + "img/cp10_02.ff3b1cca.jpg";